import { Button, Stack, TextField, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog";
import { errorToast, successToast } from "../../../components/toast";
import { useCreateEmailFooter, useUpdateEmailFooter } from "../../../services/usersApi";
import { EmailFooterInput } from "./EmailFooterInput";

export const EmailFooterConfigurationDialogMode = ((EmailFooterConfigurationDialogMode) => {
    EmailFooterConfigurationDialogMode.CREATE = "CREATE";
    EmailFooterConfigurationDialogMode.EDIT = "EDIT";
    return EmailFooterConfigurationDialogMode;
})({});

export const EmailFooterConfigurationDialog = (props) => {
    const { open, onClose, mode, sellerId, initialEmailFooter, onSuccess } = props;
    const { t } = useTranslation();

    const [name, setName] = useState(initialEmailFooter?.name || "");
    const [htmlContent, setHtmlContent] = useState(initialEmailFooter?.html_content || "");

    const { mutate: createEmailFooter, isPending: isCreatePending } = useCreateEmailFooter({
        onSuccess: () => {
            onClose();
            onSuccess?.();
            successToast(t("sellers.EmailFooterConfigurationDialog.createSuccess"));
        },
        onError: () => {
            errorToast(t("sellers.EmailFooterConfigurationDialog.createError"));
        },
    });

    const { mutate: updateEmailFooter, isPending: isUpdatePending } = useUpdateEmailFooter({
        onSuccess: () => {
            onClose();
            onSuccess?.();
            successToast(t("sellers.EmailFooterConfigurationDialog.updateSuccess"));
        },
        onError: () => {
            errorToast(t("sellers.EmailFooterConfigurationDialog.updateError"));
        },
    });

    const canSubmit = !isCreatePending && !isUpdatePending && name !== "" && htmlContent !== "";

    const handleSubmit = useCallback(
        (event) => {
            event.preventDefault();
            const requestBody = {
                name,
                html_content: htmlContent,
                seller: sellerId,
            };

            if (mode === EmailFooterConfigurationDialogMode.CREATE) {
                createEmailFooter({ sellerId, requestBody });
            } else {
                updateEmailFooter({ emailFooterId: initialEmailFooter.id, requestBody });
            }
        },
        [
            sellerId,
            name,
            htmlContent,
            mode,
            initialEmailFooter,
            createEmailFooter,
            updateEmailFooter,
        ],
    );

    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            title={t("sellers.EmailFooterConfigurationDialog.title")}
            minWidth={200}
            maxWidth={"sm"}
            showDialogActions
        >
            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <TextField
                        label={t("sellers.EmailFooterConfigurationDialog.footerName")}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        fullWidth
                    />
                    <Typography color="text.secondary" align="left">
                        {t("sellers.EmailFooterConfigurationDialog.pasteFooter")}
                    </Typography>
                    <EmailFooterInput htmlContent={htmlContent} setHtmlContent={setHtmlContent} />
                    <Button type="submit" variant="contained" disabled={!canSubmit}>
                        {t("sellers.EmailFooterConfigurationDialog.save")}
                    </Button>
                </Stack>
            </form>
        </BasicDialog>
    );
};
